<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <h3 class="title font-medium text-2xl">
        {{ $t("counselor.counselors_information") }}
      </h3>
    </div>
    <div class="md-layout-item">
      <md-card class="card-content mt-10">
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title text-lg">
              {{ $t("counselor.list_of_counselor") }}
            </h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div class="flex justify-center" v-if="!infoForm.length">
            <no-data-found></no-data-found>
          </div>
          <div
            v-else
            class="md-layout py-5 items-center"
            v-for="(info, index) in infoForm"
            :key="index"
          >
            <!-- avatar -->
            <div
              class="md-layout-item md-size-20 md-small-size-30 items-center"
            >
              <img
                :src="info.avatar_url || defaultAvatar"
                alt="Avatar counselor"
                class="object-cover rounded-full w-16 h-16 md:w-24 md:h-24"
              />
            </div>
            <!-- avatar -->

            <div class="md-layout-item md-size-70 px-0">
              <p>
                <label class="font-medium"
                  >{{ $t("common.full_name") }}:
                </label>
                <span>{{ info.full_name }}</span>
              </p>
              <p>
                <label class="font-medium">{{ $t("common.email") }}: </label>
                <span class="break-words">{{ info.email }}</span>
              </p>
              <p>
                <label class="font-medium"
                  >{{ $t("common.phone_number") }}:
                </label>
                <span>{{ info.phone_number }}</span>
              </p>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import { service_paths } from "@/constants/Services";
import { mapGetters, mapState } from "vuex";
import avatar from "../../../public/img/avt_placeholder.jpg";
import { getId } from "@/helpers/utils";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";
import NoDataFound from "../../components/Base/Illustration/NoDataFound";

export default {
  components: { NoDataFound },
  data() {
    return {
      infoForm: [],
      defaultAvatar: avatar
    };
  },
  computed: {
    ...mapGetters("user", {
      userInfo: "info"
    }),
    ...mapGetters("user", ["role"]),
    ...mapState("switchAccountChild", ["currentChild"])
  },
  created() {
    if (this.userInfo) {
      this.getData(this.userInfo);
    }
  },
  watch: {
    userInfo: function(newVal, oldVal) {
      this.getData(newVal);
    },
    currentChild: function(newVal, oldVal) {
      this.getData(this.userInfo);
    }
  },
  methods: {
    getData(userInfo) {
      let id = "";
      if (hasValidRole(this.role, Role.Family)) {
        id = getId(this.currentChild);
      } else {
        id = getId(userInfo);
      }
      if (!id) return;
      return this.$axios
        .get(`${service_paths.students}/${id}/counselors`)
        .then(response => {
          this.infoForm = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card {
  box-shadow: 0 1px 4px 0 #49494980;
}
.md-layout {
  border-bottom: 1px solid #ddd;
}
</style>
